import { useEffect } from 'react'

import { useSetUserTimeZoneMutation } from '~/redux/apis/user-api'
import useCurrentUser from '~/hooks/useCurrentUser'
import { getBrowserTimezone } from '~/utils/helpers'

export default function useUpdateUserTimezone(): void {
  const user = useCurrentUser()
  const [setUserTimeZone, { isUninitialized }] = useSetUserTimeZoneMutation()

  useEffect(() => {
    if (!user) {
      return
    }

    if (!isUninitialized) return

    const { timezone } = user
    const browserTimezone = getBrowserTimezone()

    if (browserTimezone && (!timezone || timezone !== browserTimezone)) {
      void (async function () {
        try {
          const response = await setUserTimeZone({ timezone: browserTimezone || '' }).unwrap()

          if (response.type === 'error') {
            throw response.error
          }
        } catch (error) {
          console.error(error) // eslint-disable-line no-console
        }
      })()
    }
  }, [user, setUserTimeZone, isUninitialized])
}
